import { setLocale } from "yup";

// NOTE: Buradaki keyler validation.json içinde tanımlı,
// translate işlemi ise FormItem içinde gerçekleşiyor
setLocale({
  mixed: {
    required: "required",
    notType: "notType",
    notNull: "required",
  },
  string: {
    email: "email",
    min: ({ min }) => ({
      key: "min", options: {
        min,
      },
    }),
    max: ({ max }) => ({
      key: "max", options: {
        max,
      },
    }),
  },
  number: {
    min: ({ min }) => ({
      key: "min", options: {
        min,
      },
    }),
    max: ({ max }) => ({
      key: "max", options: {
        max,
      },
    }),
  },
  array: {
    min: ({ min }) => ({
      key: "minSelectedItem", options: {
        min,
      },
    }),
    max: ({ max }) => ({
      key: "maxSelectedItem", options: {
        max,
      },
    }),
  },
});
